namespace gotoAndPlay {
    $(document).ready(function(){
        $('.submenu__item.is-current.submenu__item--haschildren > .submenu__sublist-trigger').trigger('click');
    });
}
